import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { Component, render } from "preact";
import { SessionStorage } from "../util/SessionStorage";
import { PaymentMethodComponent } from "./list/PaymentMethodComponent";
import { TipProductComponent } from "./list/TipProductComponent";
import { ReceiptComponent } from './notification/ReceiptComponent';
import { StoreNameComponent } from './notification/StoreNameComponent';
export class TipPaymentFinishComponent extends Component {
    render() {
        const paymentInfo = SessionStorage.TipPayment.getPaymentInfo();
        return (_jsxs(_Fragment, { children: [_jsx(StoreNameComponent, { storeName: paymentInfo.storeName }, void 0),
                _jsx(ReceiptComponent, { encryptedOrderCode: paymentInfo.encryptedOrderCode }, void 0),
                _jsxs("div", Object.assign({ class: "content" }, { children: [_jsx(TipProductComponent, { orderInfo: paymentInfo }, void 0),
                        _jsx(PaymentMethodComponent, { payInfo: paymentInfo }, void 0)] }), void 0)] }, void 0));
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#TipPaymentFinishComponent');
    if (root) {
        render(_jsx(TipPaymentFinishComponent, {}, void 0), root);
    }
});
